export default __webpack_public_path__ + "static/media/powerpoint.1fdfe186.svg";